// en_pms_common.ts
// Elementy wspólne dla wszystkich ekranów PMS — statusy, akcje, etykiety
// Importuj ten plik w każdym ekranowym pliku tłumaczeń zamiast powielać te same klucze.

export const enPmsCommon = {

  emptyValue: "—",
  yes: "Yes",
  no: "No",

  roomWithNumber: "Room {{number}}",
  counts: {
    rooms_one: "{{count}} room",
    rooms_other: "{{count}} rooms",
    nights_one: "{{count}} night",
    nights_other: "{{count}} nights",
    guests_one: "{{count}} guest",
    guests_other: "{{count}} guests",
    adults_one: "{{count}} adult",
    adults_other: "{{count}} adults",
    children_one: "{{count}} child",
    children_other: "{{count}} children",
  },

  navigation: {
    rooms: "Rooms & room types",
    "live-board": "Live Board",
    reservations: "Reservations",
    groups: "Groups & Blocks",
    "room-type-availability": "Room Type Availability",
    "room-availability-calendar": "Room Calendar",
    guests: "Guests",
    frontdesk: "Front Office",
    housekeeping: "Housekeeping",
    billing: "Billing",
    "night-audit": "Night Audit",
    rates: "Rates & Inventory",
    channels: "Channels",
    interfaces: "Interfaces",
    reports: "Reports",
  },
  sidebar: {
    dashboard: "Infoboard",
    openModule: "Open {{module}}",
    openExternal: "Open {{module}} (external)",
    openExternalTitle: "Open {{module}} (external, new tab)",
    customize: "Customize navigation",
    expand: "Expand navigation",
    collapse: "Collapse navigation",
    show: "Show navigation",
    hide: "Hide navigation",
    description: "Choose, arrange and expand modules to customize their subsections.",
    closeSettings: "Close navigation settings",
    subsections_one: "{{count}} subsection",
    subsections_other: "{{count}} subsections",
    hideItem: "Hide {{item}}",
    showItem: "Show {{item}}",
    shown: "Shown",
    hidden: "Hidden",
    moveItemUp: "Move {{item}} up",
    moveItemDown: "Move {{item}} down",
    moveUp: "Move up",
    moveDown: "Move down",
    reset: "Reset to default",
    done: "Done",
  },
  workspace: {
    identity: "Identity Manager",
    settings: "Settings",
    language: "Language",
    languageOptions: "Language options",
    active: "Active",
    darkMode: "Dark mode",
    logout: "Logout",
    newReservation: "New reservation",
    startCheckin: "Start check-in",
  },

  // ── Statusy pokoi ──────────────────────────────────────────────────────────
  roomStatus: {
    available:    "Available",
    occupied:     "Occupied",
    dirty:        "Dirty",
    clean:        "Clean",
    cleaning:     "Cleaning",
    inspected:    "Inspected",
    blocked:      "Blocked",
    outOfOrder:   "Out of order",
    outOfService: "Out of service",
    unassigned:   "Unassigned",
    reserved:     "Reserved",
    maintenance:  "Maintenance",
  },

  // ── Statusy rezerwacji ─────────────────────────────────────────────────────
  reservationStatus: {
    confirmed:  "Confirmed",
    inHouse:    "In-house",
    cancelled:  "Cancelled",
    checkedOut: "Checked out",
    noShow:     "No show",
    waitlist:   "Waitlist",
    pending:    "Pending",
    planned:    "Planned",
    completed:  "Completed",
    booked:     "Booked",
    active:     "Active",
    all:        "All",
  },

  roomCalendar: {
    allTypes: "All types",
    allFloors: "All floors",
    floor: "Floor {{floor}}",
    filterByFloor: "Filter by floor",
    clearFilters: "Clear",
    checkedOut: "Checked-out",
    checkedIn: "Checked-in",
    cancelledNoShow: "Cancelled / No-show",
    showCheckedOut: "Show checked-out reservations",
    hideCheckedOut: "Hide checked-out reservations",
    reservationLegend: "Reservation status legend and room filter",
    roomNumberPlaceholder: "Room no.",
    searchRoomNumber: "Search for a room number",
  },

  // ── Ważność / Priorytet ────────────────────────────────────────────────────
  severity: {
    critical: "Critical",
    high:     "High",
    medium:   "Medium",
    low:      "Low",
  },

  // ── Przyciski i akcje ──────────────────────────────────────────────────────
  actions: {
    save:        "Save",
    saving:      "Saving...",
    cancel:      "Cancel",
    cancelling:  "Cancelling...",
    close:       "Close",
    closing:     "Closing...",
    edit:        "Edit",
    delete:      "Delete",
    confirm:     "Confirm",
    approve:     "Approve",
    create:      "Create",
    creating:    "Creating...",
    add:         "Add",
    adding:      "Adding...",
    back:        "Back",
    search:      "Search",
    filter:      "Filter",
    refresh:     "Refresh",
    download:    "Download",
    preview:     "Preview",
    print:       "Print",
    send:        "Send",
    modify:      "Modify",
    viewAll:     "View all",
    viewDetails: "View details",
    opening:     "Opening...",
    set:         "Set",
  },

  // ── Stany komunikatów ──────────────────────────────────────────────────────
  state: {
    loading:   "Loading...",
    noData:    "No data",
    noResults: "No results",
    failed:    "Failed.",
  },

  // ── Wspólne etykiety pól ───────────────────────────────────────────────────
  labels: {
    guest:        "Guest",
    guests:       "Guests",
    room:         "Room",
    rooms:        "Rooms",
    floor:        "Floor",
    night:        "Night",
    nights:       "Nights",
    checkIn:      "Check-in",
    checkOut:     "Checkout",
    arrival:      "Arrival",
    departure:    "Departure",
    arrivals:     "Arrivals",
    departures:   "Departures",
    status:       "Status",
    operations:   "Operations",
    frontDesk:    "Front Desk",
    occupancy:    "Occupancy",
    revenue:      "Revenue",
    billing:      "Billing",
    housekeeping: "Housekeeping",
    department:   "Department",
    owner:        "Owner",
    priority:     "Priority",
    date:         "Date",
    time:         "Time",
    total:        "Total",
    notes:        "Notes",
    invoice:      "Invoice",
    group:        "Group",
    type:         "Type",
    rate:         "Rate",
    balance:      "Balance",
    amount:       "Amount",
    currency:     "Currency",
    name:         "Name",
    email:        "Email",
    phone:        "Phone",
    address:      "Address",
    country:      "Country",
    today:        "Today",
    other:        "Other",
    none:         "None",
    unassigned:   "Unassigned",
    inHouse:      "In-house",
    readyRoom:    "Ready room",
    noReadyRoom:  "No ready room",
  },

} as const;

export default enPmsCommon;
